// i18n bootstrap for the hotel admin app (admine). Imported once by src/index.js.
//
// Strings live in public/locales/<lang>/admin.json (one top-level key per page or
// component) and are lazy-loaded by i18next-http-backend. English is the fallback,
// so a missing translation shows English, never a raw key.
//
// Language resolution: the saved choice (localStorage 'admin_lang'), then the
// signed-in user's preferred_language (applied at login, see applyUserLanguage),
// then the browser language, then English. The choice is also saved to the
// user's profile so the staff app (frontend_appdesko.com) opens in the same
// language — both apps read UserProfile.preferred_language.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Same codes as the backend's settings.LANGUAGES and the staff app.
export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'lt', label: 'Lithuanian', nativeLabel: 'Lietuvių' },
  { code: 'fil', label: 'Filipino', nativeLabel: 'Filipino' },
  { code: 'th', label: 'Thai', nativeLabel: 'ไทย' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español' },
  { code: 'fr', label: 'French', nativeLabel: 'Français' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch' },
  { code: 'it', label: 'Italian', nativeLabel: 'Italiano' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português' },
  { code: 'id', label: 'Indonesian', nativeLabel: 'Bahasa Indonesia' },
];

const STORAGE_KEY = 'admin_lang';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    load: 'languageOnly',
    ns: ['admin'],
    defaultNS: 'admin',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: STORAGE_KEY,
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    returnNull: false,
  });

/** After login: adopt the user's saved language unless this browser already chose one. */
export function applyUserLanguage(user) {
  let saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch { /* private mode */ }
  const preferred = user?.user_profile?.preferred_language || user?.preferred_language;
  if (!saved && preferred && SUPPORTED_LANGUAGES.some((l) => l.code === preferred)) {
    i18n.changeLanguage(preferred);
  }
}

export default i18n;
